// JavaScript
import './scripts/main'

// Styles
import './assets/styles/main.scss'

// Favicon
import './assets/images/favicon.ico'

// Web App Manifest
import './site.webmanifest'
